export const changeLanguage = (language) => {
    return (dispatch) => {
        dispatch({ type: 'SET_LANGUAGE', payload: language });
    };
};